import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Download from 'pages/download';
import DownloadEetmarkets from 'pages/download/eetmarkets.js';
import DownloadEetall from 'pages/download/eetall';
import DownloadH5trade from 'pages/download/h5trade';
import DownloadPc from 'pages/download/pc/';
import notFound from 'pages/notFound';

export default () => (
  <Router>
    <Switch>
      <Route exact path="/" component={Download} />
      <Route path="/download/eetmarkets" component={DownloadEetmarkets} />
      <Route path="/down/eetall" component={DownloadEetall} />
      <Route path="/down/h5trade" component={DownloadH5trade} />
      <Route path="/down/pc" component={DownloadPc} />
      <Route path="*" component={notFound} />
    </Switch>
  </Router>
);
